import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppEnvironmentConfig } from 'projects/config/model/environment.config.model';
import { Observable, map } from 'rxjs';

import {
  SvcActionPlanEscalateBoard,
  SvcActionPlanEscalateRoom,
  SvcActionPlanEscalateSystemByApplication,
} from '../interfaces/svc-modal-action-plan.interface';

@Injectable({ providedIn: 'root' })
export class SvcActionPlanEscalateApiService {
  readonly #http = inject(HttpClient);
  readonly #appConfig = inject(AppEnvironmentConfig);

  readonly #apiActionPlan = this.#appConfig.APIs.apiUrlActionPlan;

  public getSystemByApplication(siteId: number, applicationId: string): Observable<SvcActionPlanEscalateSystemByApplication[]> {
    const params = new HttpParams().set('siteId', `${siteId}`).set('applicationId', applicationId);

    return this.#http
      .get<SvcActionPlanEscalateSystemByApplication[]>(`${this.#apiActionPlan}/system/by-application`, {
        params,
        headers: this.#getEnvironmentHeaders(),
      })
      .pipe(map((systems) => (systems ?? []).filter((system) => system?.isActive === true)));
  }

  public getRoomsWithActionPlanWidget(siteId: number): Observable<SvcActionPlanEscalateRoom[]> {
    const params = new HttpParams().set('siteId', `${siteId}`).set('active', 'true').set('validateActionPlan', 'true');

    return this.#http.get<SvcActionPlanEscalateRoom[]>(`${this.#apiActionPlan}/DigitalObeya/rooms`, {
      params,
      headers: this.#getEnvironmentHeaders(),
    });
  }

  public getBoards(siteId: number, roomId: number): Observable<SvcActionPlanEscalateBoard[]> {
    const params = new HttpParams().set('siteId', `${siteId}`).set('roomId', `${roomId}`).set('active', 'true');

    return this.#http.get<SvcActionPlanEscalateBoard[]>(`${this.#apiActionPlan}/DigitalObeya/boards`, {
      params,
      headers: this.#getEnvironmentHeaders(),
    });
  }

  #getEnvironmentHeaders(): { EnvironmentUrl: string } {
    return {
      EnvironmentUrl: this.#resolveEnvironmentUrl(),
    };
  }

  #resolveEnvironmentUrl(): string {
    const fromStorage = typeof localStorage !== 'undefined' ? localStorage.getItem('environmentUrl') : null;
    const fromWindow = typeof globalThis !== 'undefined' ? globalThis.location?.origin : '';
    return fromStorage || fromWindow || '';
  }
}
